module.exports = __webpack_public_path__ + "img/imgSrc444.601e612c.png";